import { useState } from 'react';
import { CalendarDays, ChevronDown } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { RangeCalendar } from './calendar/RangeCalendar';
import { closeoutNightsLabel, formatCloseoutDateRange } from './channelCloseoutPresentation';

/**
 * Derselbe Zeitraumkalender wie im Grundkalender, hier aufgeklappt statt als Popover: ein Popover
 * wäre über der Seitenleiste eine zweite Überlagerung, und mit den zwei Radix-Ständen im Projekt
 * sperrt die Leiste es für Klicks und Fokus. Das Ende ist Pflicht: ohne Ende bliebe der Kanal
 * unbegrenzt zu.
 */
export function ChannelCloseoutPeriodPicker({
  today,
  startDate,
  endDate,
  disabled,
  onChange,
}: {
  today: string;
  startDate: string;
  endDate: string;
  disabled: boolean;
  onChange: (from: string, to: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const chosen = Boolean(startDate && endDate);
  return (
    <div>
      <p className="text-ink-soft mb-2 text-[13px] font-medium">Zeitraum</p>
      <button
        type="button"
        aria-expanded={open}
        disabled={disabled}
        onClick={() => setOpen((current) => !current)}
        className="border-hairline bg-card hover:border-line rounded-control flex min-h-12 w-full items-center justify-between gap-3 border px-3 text-left text-sm disabled:opacity-55"
      >
        <span className="flex items-center gap-2">
          <CalendarDays size={16} className="text-ink-soft" aria-hidden />
          {chosen ? formatCloseoutDateRange(startDate, endDate) : 'Zeitraum wählen'}
        </span>
        <span className="text-ink-soft flex items-center gap-2 text-[12px]">
          {chosen && closeoutNightsLabel(startDate, endDate)}
          <ChevronDown size={16} aria-hidden className={cn(open && 'rotate-180')} />
        </span>
      </button>
      {open && (
        <div className="border-hairline bg-card rounded-control mt-2 border p-4">
          <RangeCalendar
            today={today}
            months={1}
            {...(chosen ? { initial: { from: startDate, to: endDate } } : {})}
            applyLabel="Übernehmen"
            onApply={(range) => {
              onChange(range.from, range.to);
              setOpen(false);
            }}
            onCancel={() => setOpen(false)}
          />
        </div>
      )}
    </div>
  );
}
